__turbopack_context__.v({
  "imageLink": "ArticleItemImage-module-scss-module__kTJkhq__imageLink",
});
